import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SweetAlertService } from 'src/app/services/sweetalert/sweet-alert.service';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ThankYouComponent implements OnInit {

  message: string = '';

  constructor(private router: Router,
    private sweetAlertService: SweetAlertService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((param: any) => {
      if (param) {
        if (param.status == "true") {
          this.message = param.message;
          const newMessage = this.message.replace(/-/g, ' ');
          this.sweetAlertService.sweetAlert("success", newMessage);
        } else {
          this.router.navigate(['/']);
        }
      } else {
        this.router.navigate(['/']);
      }
    })
  }

  navigateToLogIn() {
    this.router.navigate(['/']);
  }

}
